import { render, staticRenderFns } from "./journey_detail.vue?vue&type=template&id=1707eb8f&scoped=true&"
import script from "./journey_detail.vue?vue&type=script&lang=js&"
export * from "./journey_detail.vue?vue&type=script&lang=js&"
import style0 from "./journey_detail.vue?vue&type=style&index=0&id=1707eb8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1707eb8f",
  null
  
)

export default component.exports